//import Card from "@mui/material/Card";
import MKTypography from "components/MKTypography";
// Material Kit 2 React components
//import routes from "routes";
import React, { useState, useEffect } from "react";
import ReactGA from "react-ga4";
import { useQuery, useMutation } from "@apollo/client";
// Images
import { Card, CardContent, Button, TextField } from "@mui/material";
import Box from "@mui/material/Box";
import {
  CREATE_STRATEGYBUDGET,
  FIND_STRATEGYBUDGETS_BY_MUNICIPALITY,
  FIND_VOTES_BY_MUNICIPALITY,
  CREATE_VOTING,
} from "queries";
import { useTranslation } from "react-i18next";
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookMessengerShareButton,
  ThreadsShareButton,
  InstapaperShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
  EmailIcon,
  FacebookIcon,
  FacebookMessengerIcon,
  InstapaperIcon,
  LinkedinIcon,
  TelegramIcon,
  ThreadsIcon,
  //TwitterIcon,
  WhatsappIcon,
  XIcon,
} from "react-share";
//import { number } from "prop-types";
/* eslint-disable react/prop-types */
const Budgeto = ({ selectedKunta, setError }) => {
  //const Strategy = ({ selectedKunta, setSelectedKunta }) => {
  //const [t] = useTranslation("common");
  const [t] = useTranslation("common");
  //console.log(selectedKunta);
  const [amount, setAmount] = useState(10000);
  const [left, setLeft] = useState(10000);
  const [budget, setBudget] = useState([]);
  const [target, setTarget] = useState("");
  const [targetamount, setTargetamount] = useState(0);
  const [votes, setVotes] = useState([]);
  //const [token, setTokeni] = useState("");
  ////console.log(token);
  const [budgets, setBudgets] = useState([]);
  //const [verified, setVerified] = useState(false);
  //const [submitted, setSubmitted] = useState(false);
  ////console.log(submitted);
  //const [executing, setExecuting] = useState(false);
  ////console.log(executing);
  ////console.log(setExecuting);
  useEffect(() => {
    //tracker.trackPageView({});
    //console.log(localStorage.getItem("id"));
    let id = "anonym";
    if (localStorage.getItem("id") !== undefined) {
      id = localStorage.getItem("id");
    }
    //console.log(id);
    ReactGA.event({
      category: "Budget",
      action: "opened",
      label: window.location.pathname,
      value: selectedKunta,
      user: id,
    }); // optional
    //value: 99, // optional, must be a number
    //nonInteraction: true, // optional, true/false
    //transport: "xhr", // optional, beacon/xhr/image
    //});
    /*ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: id,
      municipality: selectedKunta,
    });*/
  }, []);
  const [createStrategybudget] = useMutation(CREATE_STRATEGYBUDGET, {
    refetchQueries: [
      { query: FIND_STRATEGYBUDGETS_BY_MUNICIPALITY, variables: { municipality: selectedKunta } },
    ],
    // eslint-disable-next-line
    onError: (error) => {
      setError("virhe");
      //error.graphQLErrors[0].message
      //console.log(error);
    },
  });
  const sbudgetssw = useQuery(FIND_STRATEGYBUDGETS_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });

  useEffect(() => {
    let sbudgetss = [];
    //console.log(sbudgetssw);
    //let municipalitiess = [];
    if (sbudgetssw.data) {
      sbudgetss = sbudgetssw.data.findStrategybudgetsByMunicipality;
      //setOrgans(organss);
      //console.log(sbudgetss);
      //let secs = sbudgetss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setsbudgets(secs);
      setBudgets(sbudgetss);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [sbudgetssw]);
  useEffect(() => {
    let sum = 0;
    for (let i = 0; i < budget.length; i++) {
      sum = sum + budget[i].amount;
    }
    setLeft(amount - sum);
  }, [amount]);
  const handleSubmit = () => {
    //event.preventDefault();
    const aika = Date.now();
    const pvm = new Date(aika);
    let txt = "";
    let amo = 0;
    for (let i = 0; i < budget.length; i++) {
      if (i !== 0) {
        txt = txt + ", " + budget[i].name + ": " + budget[i].amount;
        amo = parseInt(amo) + parseInt(budget[i].amount);
      } else {
        txt = budget[0].name + ": " + budget[i].amount;
        amo = parseInt(amo) + parseInt(budget[i].amount);
      }
    }
    createStrategybudget({
      variables: {
        target: txt,
        amount: amo,
        strategydatetime: pvm.toString(),
        municipality: selectedKunta,
        userid: localStorage.getItem("id"),
      },
    });
  };

  const handleRemove = (event) => {
    //console.log(event);
    let amo = budget.filter((cont) => {
      return cont.name === event;
    })[0].amount;
    //console.log(amo);
    let newbud = budget.filter((cont) => {
      return cont.name !== event;
    });
    let le = parseInt(left) + parseInt(amo);
    setLeft(le);
    //console.log(newbud);
    setBudget(newbud);
  };
  const handleAddrow = () => {
    if (targetamount > left) {
      window.confirm("Rahat eivät riitä!");
    } else {
      let newbud = { name: target, amount: targetamount };
      setBudget((budget) => [...budget, newbud]);
      setLeft(left - targetamount);
      //console.log(newbud);
      //setBudget(newbud);
      //console.log(budget);
      setTarget("");
      setTargetamount(0);
    }
  };
  const handleVote = (event) => {
    //console.log(event);
    const aika = Date.now();
    const pvm = new Date(aika);
    createVoting({
      variables: {
        strategybudgetid: event,
        userid: localStorage.getItem("id"),
        votedatetime: pvm.toString(),
        municipality: selectedKunta,
      },
    });
  };
  const votessw = useQuery(FIND_VOTES_BY_MUNICIPALITY, {
    pollInterval: 100000,
    variables: { municipality: selectedKunta },
  });
  const [createVoting] = useMutation(CREATE_VOTING, {
    refetchQueries: [
      { query: FIND_VOTES_BY_MUNICIPALITY, variables: { municipality: selectedKunta } },
    ],
    // eslint-disable-next-line
    onError: (error) => {
      //console.log(error);
      setError("virhe");
    },
    /*update: (store, response) => {
      updateCacheWith(response.data.addbudget)
    }*/
  });
  useEffect(() => {
    let votess = [];
    //console.log(votessw);
    //let municipalitiess = [];
    if (votessw.data) {
      votess = votessw.data.findVotesByMunicipality;
      //setOrgans(organss);
      //console.log(votess);
      //let secs = proposalss.filter((cont) => {
      //return cont.agendaid === meeting;
      //});
      //setProposals(secs);
      setVotes(votess);
      //municipalitiess=organsw.data.allOrgans
      //municipalitiess=organsw.data.allOrgans
    }
  }, [votessw]);
  function voteCount(p) {
    //console.log(p);
    return votes.filter((a) => a.strategybudgetid === p).length;
  }
  const shareUrl = "https://kunta.live/strategy/" + selectedKunta;
  const title = "Kunta.live";
  const divstyle = {
    backgroundColor: "white",
    borderRadius: 5,
    opacity: 0.9,
  };
  return (
    <>
      <div
        style={{
          left: "10px",
          position: "fixed",
          top: "90px",
          bottom: 0,
          height: "20px",
          color: "#C4DFE6",
          zIndex: 99,
          backgroundColor: "white",
          borderRadius: 90,
          opacity: 0.7,
        }}
        height="20px"
      >
        <div style={divstyle}>
          <FacebookShareButton url={shareUrl} className="Demo__some-network__share-button">
            <FacebookIcon size={32} round />
          </FacebookShareButton>
        </div>
        <div style={divstyle}>
          <FacebookMessengerShareButton
            url={shareUrl}
            appId="521270401588372"
            className="Demo__some-network__share-button"
          >
            <FacebookMessengerIcon size={32} round />
          </FacebookMessengerShareButton>
        </div>
        <div style={divstyle}>
          <TwitterShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <XIcon size={32} round />
          </TwitterShareButton>
        </div>
        <div style={divstyle}>
          <TelegramShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <TelegramIcon size={32} round />
          </TelegramShareButton>
        </div>
        <div style={divstyle}>
          <WhatsappShareButton
            url={shareUrl}
            title={title}
            separator=":: "
            className="Demo__some-network__share-button"
          >
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </div>
        <div style={divstyle}>
          <LinkedinShareButton url={shareUrl} className="Demo__some-network__share-button">
            <LinkedinIcon size={32} round />
          </LinkedinShareButton>
        </div>
        <div style={divstyle}>
          <EmailShareButton
            url={shareUrl}
            subject={title}
            body="body"
            className="Demo__some-network__share-button"
          >
            <EmailIcon size={32} round />
          </EmailShareButton>
        </div>
        <div style={divstyle}>
          <InstapaperShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <InstapaperIcon size={32} round />
          </InstapaperShareButton>
        </div>
        <div style={divstyle}>
          <ThreadsShareButton
            url={shareUrl}
            title={title}
            className="Demo__some-network__share-button"
          >
            <ThreadsIcon size={32} round />
          </ThreadsShareButton>
        </div>
      </div>
      <MKTypography variant="body1" color="black" textAlign="center" px={{ xs: 6, lg: 12 }} mt={1}>
        <Card style={{ marginBottom: "1rem" }}>
          <CardContent>
            <MKTypography variant="h3" gutterBottom>
              {t("budget.header")}
            </MKTypography>
            <MKTypography variant="body1" gutterBottom>
              {t("budget.text")}
            </MKTypography>
            <br />
            {t("budget.whole")}
            <TextField
              label={t("budget.sum")}
              minRows={1}
              value={amount}
              type="Number"
              onChange={(e) => setAmount(e.target.value)}
              variant="outlined"
              style={{ marginBottom: "0.5rem" }}
            />
            <br />
            <br />
            {t("budget.left")}: {left}
            <br />
            <br />
            <Box sx={{ width: "100%" }}>
              <TextField
                label={t("budget.writehere")}
                minRows={1}
                value={target}
                onChange={(e) => setTarget(e.target.value)}
                variant="outlined"
                style={{ marginBottom: "0.5rem" }}
              />
              :
              <TextField
                label={t("budget.targetsum")}
                minRows={1}
                type="number"
                value={targetamount}
                onChange={(e) => setTargetamount(e.target.value)}
                variant="outlined"
                style={{ marginBottom: "0.5rem" }}
              />
              €
              <br />
              <Button variant="contained" style={{ color: "white" }} onClick={handleAddrow}>
                {t("budget.addrow")}
              </Button>
              <br />
              <br />
              <MKTypography
                variant="body1"
                gutterBottom
                style={{ width: "100%", textAlign: "center" }}
              >
                <table style={{ width: "100%", textAlign: "center" }}>
                  {budget.map((item) => (
                    <tr key={item.name}>
                      <td>
                        {item.name} : {item.amount} €
                      </td>
                      <td>
                        <Button
                          variant="contained"
                          style={{ color: "white" }}
                          onClick={() => handleRemove(item.name)}
                        >
                          {t("budget.delete")}
                        </Button>
                      </td>
                    </tr>
                  ))}
                </table>
              </MKTypography>
              <br />
              <br />
              <Button variant="contained" style={{ color: "white" }} onClick={handleSubmit}>
                {t("budget.save")}
              </Button>
              <br />
              <br />
            </Box>
          </CardContent>
        </Card>
      </MKTypography>
      <MKTypography variant="h4" gutterBottom>
        {t("budget.saved")}
      </MKTypography>
      {budgets.length === 0 && <MKTypography>{t("budget.nosaved")}</MKTypography>}
      {budgets.map((item, index) => (
        <Card key={index} style={{ marginBottom: "0.5rem" }}>
          <CardContent
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <MKTypography>
              {item.target} | {t("budget.sum")} {item.amount}
            </MKTypography>
            <Button
              variant="contained"
              style={{ color: "white" }}
              onClick={() => handleVote(item.id)}
            >
              👍 {voteCount(item.id)}
            </Button>
          </CardContent>
        </Card>
      ))}
    </>
  );
};

export default Budgeto;
